import React from 'react';
import AppView from './AppView';

export default () => {
  console.log(process.env.REACT_APP_SEVER_NAME);
  return <AppView />;
};
